"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));
/**
 * The only true button.
 *
 * @since 1.2.2
 * @component
 */


var Form =
/** @class */
function (_super) {
  __extends(Form, _super);

  function Form() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * Intercepts event and capture form values
     *
     * onSubmit function
     * @param {React.SyntheticEvent} event The react `SyntheticEvent`
     */


    _this.onSubmit = function (event) {
      event.preventDefault();
      var _a = _this.props,
          onSubmit = _a.onSubmit,
          refs = _a.refs;
      var elements = event.target.elements;
      /**
       * another way of fetching data
       */

      var formData = {};
      refs.forEach(function (el) {
        var refFormData = el.current.getValues();
        Object.keys(refFormData).forEach(function (id) {
          formData[id] = refFormData[id];
        });
      }); // loop over elements

      for (var key in elements) {
        if (elements.hasOwnProperty(key)) {
          var el = elements[key]; // @ts-ignore

          if (el.name) {
            // @ts-ignore
            formData[el.name] = el.value;
          }
        }
      }

      onSubmit(formData);
    };

    return _this;
  }
  /**
   * Renders the component.
   *
   * @return {string} - HTML markup for the component
   */


  Form.prototype.render = function () {
    var _a = this.props,
        _b = _a.autoComplete,
        autoComplete = _b === void 0 ? 'on' : _b,
        children = _a.children;
    return react_1.default.createElement("form", {
      onSubmit: this.onSubmit,
      autoComplete: autoComplete
    }, children);
  };

  Form.defaultProps = {
    refs: []
  };
  return Form;
}(react_1.PureComponent);

exports.default = Form;